
// --- Vue & Template imports ---
import { Component, Vue } from 'vue-property-decorator';

// --- Models ---
import { MessageDestination } from '@/models/Sms.model';

// --- Services ---
import AppService from '@/services/app';
import DriverService from '@/services/driver';
import MessageService from '@/services/message';
import VehicleService from '@/services/vehicle';

// --- Third Party ---

@Component
export default class BulkMessagePage extends Vue {

  // used by Filter Area
  //search: string = '';
  filterOptions: string[] = ['All', 'Drivers', 'Vehicles'];
  destinationFilter: string = 'All';

  message: string = '';
  messageDestinations: MessageDestination[] = [];
  selectedDestinations: MessageDestination[] = [];

  messageFormValid: boolean = false;
  sendMessageClicked: boolean = false;

  rules = {
    required: (value: string) => !!value || '',
  };

  // #region Functions to display list data on page load
    headers() {
      return [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Contact',
          value: 'contact',
        },
      ];
    }

    async beforeMount() {
      await DriverService.listActive(false);
      await VehicleService.listTypes(false);
      await VehicleService.listActive(false);

      this.filterDestinations();
    }

    async filterDestinations() {
      switch (this.destinationFilter) {
        case ('All'):
          this.messageDestinations = [];
          this.selectedDestinations = [];

          this.messageDestinations = this.$store.getters['vehicles/vehiclesByType']('Horse').reduce((a: any, b: any) => {
            let newItem: MessageDestination = {
              id: b.id,
              isHorse: true,
              name: b.code,
              contact: b.cellNumber,
            };

            return a.concat(newItem);
          }, []).concat(
            this.$store.getters['drivers/activeDrivers'].reduce((a: any, b: any) => {
              let newItem: MessageDestination = {
                id: b.id,
                isHorse: false,
                name: b.nickname,
                contact: b.cellNumber + (b.cellNumber2 ? ', ' + b.cellNumber2 : ''),
              };

              return a.concat(newItem);
            }, [])
          );
          break;

        case ('Drivers'):
          this.messageDestinations = [];
          this.selectedDestinations = [];

          this.messageDestinations = this.$store.getters['drivers/activeDrivers'].reduce((a: any, b: any) => {
              let newItem: MessageDestination = {
                id: b.id,
                isHorse: false,
                name: b.nickname,
                contact: b.cellNumber + (b.cellNumber2 ? ', ' + b.cellNumber2 : ''),
              };

              return a.concat(newItem);
            }, []);
          break;

        case ('Vehicles'):
          this.messageDestinations = [];
          this.selectedDestinations = [];

          this.messageDestinations = this.$store.getters['vehicles/vehiclesByType']('Horse').reduce((a: any, b: any) => {
            let newItem: MessageDestination = {
              id: b.id,
              isHorse: true,
              name: b.code,
              contact: b.cellNumber,
            };

            return a.concat(newItem);
          }, []);
          break;
      }
    }

    async sendMessage() {
      try {
        this.sendMessageClicked = true;

        const response = await MessageService.create({ 
          destinations: this.selectedDestinations,
          message: this.message,
        });

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            AppService.errorHandler(response.data.message);
          } else {
            AppService.successHandler(response.data.message);

            this.message = '';
            this.selectedDestinations = [];

            this.$nextTick(() => {
              if (this.$refs.messageForm) {
                ((this.$refs.messageForm) as any).resetValidation();
              }
            });
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.logSupportDebug('BulkMessaging.vue - sendMessage - 276 - ' + error);
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }
      } finally {
        this.sendMessageClicked = false;
      }
    }
  // #endregion
}
